import React from 'react';
import { useTranslation } from 'react-i18next';
import { BackButton } from './BackButton';

const PermissionDenied = ({ fallbackPath = '/dashboard' }) => {
  const { t } = useTranslation();
  return (
    <div className="p-4 md:p-6">
      <BackButton fallbackPath={fallbackPath} />
      <div className="bg-red-50 border border-red-200 rounded-lg p-8 text-center mt-6">
        <svg className="w-16 h-16 text-red-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <h2 className="text-xl font-bold text-red-800 mb-2">{t('shared.permissionDenied.title')}</h2>
        <p className="text-red-600">{t('shared.permissionDenied.message')}</p>
      </div>
    </div>
  );
};

export default PermissionDenied;
